import { trustHTML } from '@ember/template';
import Component from '@glimmer/component';
import { or } from 'ember-truth-helpers';
import { local } from 'embroider-css-modules';

import type { TooltipOptions } from '../../../../types/components/prism/data-bar.ts';
import {
  COLOR_TEXT_SUBDUED,
  getCssVariableValue,
} from '../../../../utils/css-variable.ts';
import PrismIcon from '../../icon.gts';
import PrismTooltip from '../../tooltip.gts';
import styles from '../data-bar-label-value-target.module.css';

interface PrismDataBarBlocksDataBarLabelSignature {
  Args: {
    color?: string;
    text?: string;
    tooltip?: TooltipOptions;
  };
  Blocks: {
    default: [];
  };
}

export default class PrismDataBarBlocksDataBarLabel extends Component<PrismDataBarBlocksDataBarLabelSignature> {
  get styleForColor(): string {
    const color = this.args.color ?? getCssVariableValue(COLOR_TEXT_SUBDUED);

    return `color: ${color}`;
  }

  <template>
    {{#if (has-block)}}
      <div class={{styles.label}}>
        {{yield}}
      </div>
    {{else}}
      <div
        class={{local styles "label" "has-texts"}}
        style={{trustHTML this.styleForColor}}
      >
        <p class="truncate">{{@text}}</p>

        {{#if @tooltip.message}}
          <div class={{styles.tooltip}}>
            <PrismIcon
              @color={{@tooltip.color}}
              @name="circle-information-outline"
              @size={{or @tooltip.iconSize "small"}}
            />
            <PrismTooltip
              @side={{@tooltip.side}}
              @text={{@tooltip.message}}
              @title={{@tooltip.title}}
            />
          </div>
        {{/if}}
      </div>
    {{/if}}
  </template>
}
